import { Box, TextField, TextFieldProps } from "@mui/material";
import { useLanguages } from "../../../../../components/CustomizableTexts/CustomizableTexts";
import { Controller, useWatch } from "react-hook-form";
import _ from "lodash";
import { LanguageSelect } from "../../../../../components/TranslatableEditor/LanguageSelect";
import React from "react";
import { TranslationsStorage } from "../../../../../components/TranslatableEditor/TranslatableEditor.d";

export function TranslatableTextField({
  translatableText,
  name,
  onUpdated,
  ...inputProps
}: {
  translatableText: string;
  name: string;
  onUpdated?: (newTranslations: TranslationsStorage) => void;
} & TextFieldProps) {
  const { selectedLanguage, activeLanguages, changeLanguage } = useLanguages();
  const translations: TranslationsStorage = useWatch({ name });

  return (
    <Controller
      name={name}
      render={(props) => (
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            color={"primary"}
            onChange={(event) => {
              const newTranslations = { ...translations };
              // <3 lodash
              _.set(newTranslations, `[${selectedLanguage.value}][${translatableText}]`, event.target.value);
              props.field.onChange(newTranslations);
              onUpdated?.(newTranslations);
            }}
            style={{ width: "100%" }}
            value={translations?.[selectedLanguage.value]?.[translatableText] ?? ""}
            {...inputProps}
          />
          <LanguageSelect
            allowedLanguages={activeLanguages}
            language={selectedLanguage.value}
            onChange={changeLanguage}
          />
        </Box>
      )}
    />
  );
}
